export default __webpack_public_path__ + "static/company-bdf143ac499e0fe49c8860b3d931b243.mp4";